/* Copyright (c) 2017 Backpack Health LLC */

import React from 'react'
import { FormattedMessage } from 'react-intl';
import classnames from 'classnames';

import MenuSwitcher from './MenuSwitcher';
import { BackButton } from 'components/common/Button';
import GroupMenuSwitcher from 'components/features/GroupMenuSwitcher';

import './PageHeader.css';
import GroupLogo from '../GroupLogo';
import BackpackLogo from '../../images/BackpackLogo';

const PageHeader = (props) => {
  const { goBack, titlePhrase, isLoggedIn, openSidebar, onClickLogo, mainTitle, subTitle, subTitlePhrase, titleClassName } = props;

  return (
    <>
      <div className="cmp-pageheader">
        <div className="cmp-pageheader-navtitle">
          <span className="groupmenu">
            <GroupMenuSwitcher hideName={true} onClick={isLoggedIn ? openSidebar : onClickLogo} />
          </span>

          { goBack ? <span className="backnavigation"><BackButton onClick={goBack} /></span> : null }

          <span>
            <div className="cmp-pageheader-minorheading font-footnote font-color-gsDarkest">
              {subTitle || (
                subTitlePhrase && <FormattedMessage {...subTitlePhrase} />
              )}
            </div>
            <div className={classnames('cmp-pageheader-title', titleClassName)}>
              {mainTitle || (
                titlePhrase && <FormattedMessage {...titlePhrase} />
              )}
            </div>
          </span>

        </div>

        <div className="cmp-pageheader-menuswitcher">
          <MenuSwitcher />
        </div>
      </div>
      <div className="_dropshadow" />
    </>
  );
}

export const LoggedOutPageHeaderTemplate = (props) => {
  const { goBack, logo, titlePhrase, onClickLogo, mainTitle, subTitle, subTitlePhrase, titleClassName } = props;

  return (
    <div className="cmp-pageheader">
      <div className="cmp-pageheader-navtitle">
        <span className="_logo" onClick={onClickLogo}>
          {logo}
        </span>

        { goBack ? <span className="backnavigation"><BackButton onClick={goBack} /></span> : null }

        <span>
          <div className="cmp-pageheader-minorheading font-footnote font-color-gsDarkest">
            {subTitle || (
              subTitlePhrase && <FormattedMessage {...subTitlePhrase} />
            )}
          </div>
          <div className={classnames('cmp-pageheader-title', titleClassName)}>
            {mainTitle || (
              titlePhrase && <FormattedMessage {...titlePhrase} />
            )}
          </div>
        </span>

      </div>

      <div className="cmp-pageheader-menuswitcher">
        <MenuSwitcher />
      </div>
    </div>
  );
}

const MissingLogo = () => (
  <div className="cmp-pageheader-logo"><BackpackLogo className="theme-group base fill" /></div>
);

export const DashboardThemedPageHeaderTemplate = (props) => (
  <PageHeader {...props} titleClassName="font-color-dvFjordBlue" />
);

export const GroupThemedPageHeaderTemplate = (props) => (
  <PageHeader {...props} titleClassName="theme-group base color" />
);

export const GroupThemedLoggedOutPageHeaderTemplate = (props) => {
  const { logo = (<GroupLogo hasDots={false} BackupLogo={MissingLogo} size="48px" />) } = props;
  return (
    <LoggedOutPageHeaderTemplate {...props} titleClassName="theme-group base color font-title-2" logo={logo} />
  );
};


export const BackpackThemedPageHeaderTemplate = (props) => {
  return (
    <LoggedOutPageHeaderTemplate {...props} titleClassName="theme-group base color font-title-2" logo={(<div className="cmp-pageheader-logo"><BackpackLogo className="theme-group base fill" /></div>)} />
  );
};

export default PageHeader;
